import React from 'react'
import Layout from '../components/Layout'
import Hero from '../components/Hero'
import Contact from '../components/Contact'

export default function contact() {
    return (
        <Layout>
            <Hero />
            <Contact />
        </Layout>
    )
}
